import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Key, CheckCircle2 } from 'lucide-react';
const marqueeImages = ['https://cdn.magicpatterns.com/uploads/oaHApvkXpKRXBRckZVRYwc/ChatGPT_Image_1_may_2026,_12_40_06_a.m..webp', 'https://cdn.magicpatterns.com/uploads/dte2AmpLsjZfZ9zt84zYdt/ChatGPT_Image_1_may_2026,_12_38_45_a.m..webp', 'https://cdn.magicpatterns.com/uploads/sMHRu5jt5HHiPvaDRTqji9/ChatGPT_Image_1_may_2026,_12_38_41_a.m..webp', 'https://cdn.magicpatterns.com/uploads/crU8tGZ3KyqGsgbePRDag1/ChatGPT_Image_1_may_2026,_12_38_37_a.m..jpg', 'https://cdn.magicpatterns.com/uploads/5dEMMeebqNQDJrfKtDaxMF/ChatGPT_Image_1_may_2026,_12_38_32_a.m..jpg'];
export function SolutionSection() {
  const steps = ['Qué comprar, qué evitar y cómo no regalar plata desde el primer día', 'El método exacto para dejar de improvisar y lograr resultados profesionales', 'Cómo evitar errores caros, presupuestar bien y convertir esto en ingresos reales'];
  return <section className="py-20 px-4 bg-[#0a0a0a] relative overflow-hidden pt-[41px] pb-[41px]" data-id="element-366">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(245,197,24,0.03),transparent_70%)] pointer-events-none" data-id="element-367" />

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-369">
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tighter" data-id="element-370">
            Lo que necesitás es un{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-yellow via-[#FFD700] to-brand-yellow drop-shadow-[0_0_15px_rgba(245,197,24,0.3)]" data-id="element-371">
              paso a paso claro
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-400 mb-12 font-medium italic" data-id="element-372">
            Saber exactamente:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-373">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} whileHover={{
            y: -8,
            transition: {
              duration: 0.2
            }
          }} className="group relative bg-gradient-to-b from-[#1a1a1a] to-[#111] p-8 rounded-[2rem] border border-white/5 flex flex-col items-center gap-6 text-center shadow-2xl hover:border-brand-yellow/40 transition-all duration-500" data-id="element-374">
                {/* Premium Icon Container */}
                <div className="relative" data-id="element-375">
                  <div className="absolute inset-0 bg-brand-yellow/20 blur-xl rounded-full group-hover:bg-brand-yellow/40 transition-all duration-500" data-id="element-376" />
                  <div className="relative z-10 w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-yellow to-brand-gold flex items-center justify-center shadow-[0_0_20px_rgba(245,197,24,0.4)]" data-id="element-377">
                    <CheckCircle2 className="w-8 h-8 text-black" strokeWidth={3} data-id="element-378" />
                  </div>
                </div>

                <span className="text-lg md:text-xl font-bold text-white leading-snug tracking-tight" data-id="element-379">
                  {step}
                </span>

                {/* Decorative bottom line */}
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/3 h-[2px] bg-gradient-to-r from-transparent via-brand-yellow/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-380" />
              </motion.div>)}
          </div>

          <div className="bg-[#0a0a0a] overflow-hidden py-12 mb-10 pt-[8px] pb-[8px]" data-id="element-381">
            <div className="flex" style={{
            animation: 'marqueeScroll 40s linear infinite',
            width: 'max-content',
            willChange: 'transform'
          }} data-id="element-382">
              {[...marqueeImages, ...marqueeImages].map((src, index) => <img key={index} src={src} alt={`Resultado detailing ${index % marqueeImages.length + 1}`} width={400} height={300} loading="lazy" className="flex-shrink-0 object-cover rounded-xl mx-3" style={{
              width: '50vw',
              height: 'auto'
            }} data-id="element-383" />)}
            </div>
            <style data-id="element-384">{`
              @keyframes marqueeScroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
            `}</style>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative py-8 px-4 pt-[10px] pb-[10px]" data-id="element-385">
            {/* Golden glow effect */}
            <div className="absolute inset-0 bg-brand-yellow/5 blur-[60px] rounded-full pointer-events-none" data-id="element-386" />

            <div className="relative z-10 flex flex-col items-center gap-2" data-id="element-387">
              <p className="text-lg md:text-xl font-medium text-gray-500 uppercase tracking-[0.2em]" data-id="element-388">
                Antes: <span className="text-gray-400" data-id="element-389">Deteriorado</span>
              </p>

              <div className="h-px w-12 bg-gradient-to-r from-transparent via-brand-yellow/30 to-transparent my-2" data-id="element-390" />

              <p className="text-3xl md:text-5xl font-black tracking-[0.1em] uppercase" data-id="element-391">
                <span className="text-white/90" data-id="element-392">Después: </span>
                <span className="text-brand-yellow drop-shadow-[0_0_10px_rgba(245,197,24,0.2)] italic" data-id="element-393">
                  Renovado
                </span>
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}